import { render } from "./FeedbackPopover.vue?vue&type=template&id=703f4cea&scoped=true"
import script from "./FeedbackPopover.vue?vue&type=script&lang=js"
export * from "./FeedbackPopover.vue?vue&type=script&lang=js"

import "./FeedbackPopover.vue?vue&type=style&index=0&id=703f4cea&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703f4cea"]])

export default __exports__